import { InputsModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ReactiveFormsModule } from '@angular/forms';
import { AssessmentExportComponent } from './assessment-export.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { PopupModule } from '@progress/kendo-angular-popup';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { DateInputsModule } from '@progress/kendo-angular-dateinputs';
import { AdvancedModeModule } from '../advanced-mode/advanced-mode.module';

@NgModule({
  imports: [
    CommonModule,
    DialogsModule,
    PopupModule,
    TranslateModule,
    ReactiveFormsModule,
    DropDownsModule,
    DateInputsModule,
    LabelModule,
    InputsModule,
    AdvancedModeModule,
  ],
  declarations: [AssessmentExportComponent],
  exports: [AssessmentExportComponent]
})
export class AssessmentExportModule { }
